import React, { ReactNode } from 'react'
import { ThemeProvider } from 'styled-components/macro'
import { theme } from './default'

export function ALThemeProvider({ children }: { children: ReactNode }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>
}
